import type { ReactNode } from 'react';
import type { BuildStatus } from '@hangar/shared';
import { StatusPill } from '@/components/badges';
import { statusLabel } from './buildLabels';

/**
 * A build's current status: a StatusPill with the build waiting set (`queued` pulses too) and the label in plain words
 * ("Waiting in the build queue"). `label` replaces the text (narrow columns).
 */
export function BuildStatusPill({ status, label, size = 'sm', className }: { status: BuildStatus; label?: ReactNode; size?: 'sm' | 'md'; className?: string }) {
  return <StatusPill status={status} motion="build" label={label ?? statusLabel(status)} size={size} className={className} />;
}
